"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseBitMatrix = exports.stringifyIBitMatrix = exports.IBitMatrix = void 0;
var utils_1 = require("../../../utils");
exports.IBitMatrix = (0, utils_1.IRecord)({
    width: 0,
    height: 0,
    data: (0, utils_1.ReadonlyBitArray)()
});
var stringifyIBitMatrix = function (bm) {
    return JSON.stringify({
        width: bm.width,
        height: bm.height,
        data: bm.data.toString()
    });
};
exports.stringifyIBitMatrix = stringifyIBitMatrix;
var is01str = function (str) { return !/![01]/.test(str); };
var parseBitMatrix = function (bmStr) {
    if (bmStr === '')
        return undefined;
    var parsed = JSON.parse(bmStr);
    if (parsed == null)
        return undefined;
    var data = parsed.data;
    if ((0, utils_1.isNotString)(data))
        return undefined;
    if (is01str(data))
        return undefined;
    return (0, exports.IBitMatrix)({
        width: parsed.width,
        height: parsed.height,
        data: (0, utils_1.ReadonlyBitArrayFromStr)(data)
    });
};
exports.parseBitMatrix = parseBitMatrix;
